import { ng } from '@uirouter/angularjs/lib/angular';
import { IHttpInterceptor, IRequestConfig } from 'angular';
import * as angular from 'angular';
import { Array } from 'es6-shim';

angular
    .module('app.common')
    .config(['$httpProvider', ($httpProvider: ng.IHttpProvider) => {
        $httpProvider.interceptors.push('apiVersionInterceptor');
    }]);

export class ApiVersionInterceptor implements IHttpInterceptor {
    public static $inject = ['$q'];
    private sessionStorageErrorKey = 'jisp_api_version_error';

    constructor(
        private $q: ng.IQService
    ) {
    }

    public request = (config: IRequestConfig) => {
        const url = config.url;
        if (url.includes(jispPayApiUrl)) {
            config.headers['X-Api-Version'] = jispPayApiVersion;
        } else if (url.includes(retailerApiUrl)) {
            config.headers['X-Api-Version'] = retailerApiVersion;
        } else if (url.includes(adminApiUrl)) {
            config.headers['X-Api-Version'] = adminApiVersion;
        }

        return config;
    }

    public response = <T>(response: ng.IHttpResponse<T>) => {
        return response || this.$q.when(response);
    }

    public responseError = (rejection: ng.IHttpResponse<any>) => {
        if (rejection && rejection.data && rejection.data instanceof Array) {
            const apiVersionError = rejection.data.find((item) => item.Key === 'ApiVersion');
            if (!!apiVersionError) {
                const hasAlreadyBeen = sessionStorage.getItem(this.sessionStorageErrorKey);
                if (!hasAlreadyBeen) {
                    sessionStorage.setItem(this.sessionStorageErrorKey, 'true');
                    location.reload(true);
                }
            }
        }
        return this.$q.reject(rejection);
    }
}

angular.module('app.common').service('apiVersionInterceptor', ApiVersionInterceptor);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/interceptors/api-version.interceptor.ts